export const OilIcon = ({ k, className = '' }) => (
  <img src={`/oil/ic_${k}.webp`} alt="" className={`inline-block h-[1.15em] w-auto align-[-0.18em] ${className}`} />
);

/* moeda KAKO — a mesma arte usada na escolha de pacotes da loja */
export const KAKO_COIN_IMG = 'https://customer-assets.emergentagent.com/job_8f198eda-3cd9-45f6-a741-5b80db2d25c7/artifacts/uhy6yxmh_ChatGPT%20Image%2015%20de%20fev.%20de%202026%2C%2013_18_27.png';

export const KakoCoin = ({ className = '' }) => (
  <img src={KAKO_COIN_IMG} alt="moedas" data-testid="kako-coin-icon"
    className={`inline-block h-[1.4em] w-auto align-[-0.3em] ${className}`} />
);
